import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../shared/components';
import { useApi } from '../../shared/context';
import { QueryKeys } from '../../shared/hooks';
import { CallStatusesMap, DataRoomCall } from '../../shared/models';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { getResponseData } from '../../shared/utils/axios';

interface ConfirmCallDialogProps {
	dataRoomGuid: string | undefined;
	call: DataRoomCall | null;
	close: () => void;
}

export const ConfirmCallDialog: React.FC<ConfirmCallDialogProps> = ({ dataRoomGuid, call, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onConfirmation = () => {
		if (call !== null) confirmRequest(call);
	};

	const { mutate: confirmRequest } = useMutation<void, unknown, DataRoomCall>(
		request =>
			getResponseData(
				api.patch(CerebroApiEndpoints.Calls.Existing(dataRoomGuid, request.guid), {
					callDate: call?.callDate,
					callDetails: call?.callDetails,
					callTimeZone: call?.callTimeZone,
					callStatus: CallStatusesMap.Completed,
				})
			),
		{
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.Calls.Root(dataRoomGuid));
				snackbar.enqueueSnackbar('Call status successfully updated.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem updating the schedule.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={call !== null} onClose={close}>
			<DialogTitle>Mark Complete</DialogTitle>
			<DialogContent>
				<DialogContentText>Are you sure you want to mark this call as complete?</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
